<template>
    <div :class="['layout-inline-menu', { 'layout-inline-menu-active': activeInlineProfile }]" v-if="!isMobile() && (isStatic() || isSlim() || isSidebar())">
        <a class="layout-inline-menu-action" @click="onChangeActiveInlineMenu">
            <img src="layout/images/profile-image.png" alt="avatar" style="width: 44px; height: 44px" />
            <span class="layout-inline-menu-text" v-if="$store.state.simadu.simadu_role">{{ $store.state.simadu.simadu_role.nama_lengkap_users }}</span>
            <i class="layout-inline-menu-icon pi pi-angle-down"></i>
        </a>

        <transition name="layout-inline-menu-action-panel" @click="onChangeActiveInlineMenu">
            <ul v-show="activeInlineProfile" class="layout-inline-menu-action-panel">
                <li class="layout-inline-menu-action-item" v-for="item in list_role" :key="item.master_user_id">
                    <a @click="konfirm_role(item)" :class="item.kode_role == role_aktif.kode_role ? 'aktif' : null">
                        <i class="pi pi-user pi-fw"></i>
                        <span>{{ item.nama_role }} - {{ item.kode_program_studi_prodi }}</span>
                    </a>
                </li>
                <li class="layout-inline-menu-action-item" @click="konfirm_logout()">
                    <a>
                        <i class="pi pi-power-off pi-fw"></i>
                        <span>Logout</span>
                    </a>
                </li>
                <!-- <li class="layout-inline-menu-action-item">
                    <a>
                        <i class="pi pi-cog pi-fw"></i>
                        <span>Settings</span>
                    </a>
                </li> -->
                <!-- <li class="layout-inline-menu-action-item">
                    <a>
                        <i class="pi pi-user pi-fw"></i>
                        <span>Profile</span>
                    </a>
                </li> -->
            </ul>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'AppInlineMenu',
    emits: ['change-inlinemenu'],
    props: {
        menuMode: String,
        activeInlineProfile: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        list_role() {
            return this.$store.state.simadu.list_role;
        },
        role_aktif() {
            return this.$store.state.simadu.role_aktif ? this.$store.state.simadu.role_aktif : null;
        },
    },
    methods: {
        onChangeActiveInlineMenu(event) {
            this.$emit('change-inlinemenu', event);
            event.preventDefault();
        },
        isHorizontal() {
            return this.menuMode === 'horizontal';
        },
        isSlim() {
            return this.menuMode === 'slim';
        },
        isOverlay() {
            return this.menuMode === 'overlay';
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        isSidebar() {
            return this.menuMode === 'sidebar';
        },
        isDesktop() {
            return window.innerWidth > 991;
        },
        isMobile() {
            return window.innerWidth <= 991;
        },
        changeRole(data) {
            this.$store.commit('change_role_aktif', data);
            this.$router.push('/dashboard');
            this.$confirm.close();
        },
        konfirm_role(data) {
            this.$confirm.require({
                message: `Apakah anda yakin mengubah role Anda menjadi ${data.nama_role} ${data.kode_program_studi_prodi? data.kode_program_studi_prodi : ''}  ?`,
                header: 'Konfirmasi',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.changeRole(data);
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },
        logouts() {
            this.$store.commit('set_clear_token');
            this.$router.push('/logout');
        },
        konfirm_logout() {
            this.$confirm.require({
                message: `Apakah anda yakin logout  ?`,
                header: 'Konfirmasi',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.logouts();
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },
    },
};
</script>

<style scoped>
.aktif {
    color: green !important;
    font-weight: 700 !important;
}
</style>
